import React, { useRef, useEffect } from "react";
import { filterCourses } from "../../actions/Course.action";
import FormInput from "../../components/form-input/form-input.component";
import { connect ,useSelector } from "react-redux";
import { Input } from 'antd';

const ContactFilter = ({ filterCourses }) => {
  const {filtered} = useSelector(state => state.courses.filtered)
  useEffect(() => {
    if (filtered === null) {
      text.current.value = "";
    }
  });
  const text = useRef("");

  const onChange = (e) => {
    filterCourses(e.target.value);
  };

  return (
  
    <Input 
    className="filter-input"
    name="title"
    type="text"
    ref={text}
    onChange={onChange}
    placeholder=" للبحث ادخل اسم المادة او الفصل الدراسي او استاذ المادة  ..." 
     />
  );
};




export default connect(null, { filterCourses })(ContactFilter);
